module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAQCAYAAADXnxW3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAhSURBVHgBlcixDQAACIRA4v4zsKrGylj+dYDanM3iS94ATWoORNqqIkkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/thank/dot.png
// module id = WiAq
// module chunks = 1